import React from 'react';
import ConsultationModal from './ConsultationModal';

const CareerConsultModal = ({ showModal, setShowModal }) => {
    return <ConsultationModal showModal={showModal} setShowModal={setShowModal} ctaType="career" />;
};

export default CareerConsultModal;